import { Status } from '@tiendanube/common/src/enums';
import { SavedSearchInterface } from './types';

function serializeMultipleOptions(filterOptions: Status[]): string {
  return filterOptions.join(',');
}

export enum DefaultSavedSearchesCode {
  PAYMENT_PENDING = 'paymentPending',
  READY_TO_PACK = 'readyToPack',
  READY_TO_SEND = 'readyToSend',
  READY_TO_PICKUP = 'readyToPickup',
  READY_TO_ARCHIVE = 'readyToArchive',
}

// Used as a fallback if we fail to load the Saved Searches from the API
export const defaultSavedSearches = [
  {
    id: DefaultSavedSearchesCode.PAYMENT_PENDING,
    key: DefaultSavedSearchesCode.PAYMENT_PENDING,
    name: '',
    isDefault: true,
    hidden: false,
    filters: {
      status: Status.OPEN,
      paymentStatus: serializeMultipleOptions([
        Status.PENDING,
        Status.PARTIALLY_PAID,
      ]),
    },
  },
  {
    id: DefaultSavedSearchesCode.READY_TO_PACK,
    key: DefaultSavedSearchesCode.READY_TO_PACK,
    name: '',
    isDefault: true,
    hidden: false,
    filters: {
      status: Status.OPEN,
      paymentStatus: serializeMultipleOptions([
        Status.PAID,
        Status.PARTIALLY_PAID,
        Status.PARTIALLY_REFUNDED,
      ]),
      fulfillmentStatus: serializeMultipleOptions([
        Status.UNPACKED,
        Status.PARTIALLY_PACKED,
      ]),
    },
  },
  {
    id: DefaultSavedSearchesCode.READY_TO_SEND,
    key: DefaultSavedSearchesCode.READY_TO_SEND,
    name: '',
    isDefault: true,
    hidden: false,
    filters: {
      status: Status.OPEN,
      paymentStatus: serializeMultipleOptions([
        Status.PAID,
        Status.PARTIALLY_REFUNDED,
      ]),
      fulfillmentStatus: serializeMultipleOptions([
        Status.UNFULFILLED,
        Status.PARTIALLY_FULFILLED,
      ]),
    },
  },
  {
    id: DefaultSavedSearchesCode.READY_TO_PICKUP,
    key: DefaultSavedSearchesCode.READY_TO_PICKUP,
    name: '',
    isDefault: true,
    hidden: false,
    filters: {
      status: Status.OPEN,
      paymentStatus: serializeMultipleOptions([
        Status.PAID,
        Status.PARTIALLY_REFUNDED,
      ]),
      fulfillmentStatus: Status.PICKUP_READY,
    },
  },
  {
    id: DefaultSavedSearchesCode.READY_TO_ARCHIVE,
    key: DefaultSavedSearchesCode.READY_TO_ARCHIVE,
    name: '',
    isDefault: true,
    hidden: false,
    filters: {
      status: Status.OPEN,
      paymentStatus: serializeMultipleOptions([
        Status.PAID,
        Status.PARTIALLY_REFUNDED,
      ]),
      fulfillmentStatus: serializeMultipleOptions([
        Status.FULFILLED,
        Status.DELIVERED,
      ]),
    },
  },
] as SavedSearchInterface[];
